import { getCookieValue } from 'components/analytics/utils';
import { ANON_ID_COOKIE } from 'utils/cookies';
import { isBrowser } from 'utils/environment';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

/**
 * Statsig rollout gate controlling the Segment->GTM migration.
 */
export const GTM_DIRECT_ROUTING_GATE = 'chime_com_gtm_direct_routing';

export function isGtmDirectRoutingEnabled(): boolean {
  return isBrowser() && window.__CHIME_CONFIG__?.gtmDirectRoutingEnabled === true;
}

/**
 * Segment events forwarded directly into the GTM dataLayer. The GTM-N3Z9ZNR
 * container keys its custom-event triggers on these names.
 *
 * These events are ALSO sent through Segment with the Segment->GTM destination
 * disabled (see libs/segment.ts), so GTM receives each one exactly once via the
 * dataLayer while every other Segment destination keeps receiving it.
 */
export const GTM_DESTINATION_EVENTS = new Set([
  'FAQ Arrow Clicked',
  'Floating Disclaimer Shown',
  'Landing Page Email Filled',
  'Landing Page Experiment Viewed',
  'Lead Generation Interaction Captured',
  'Login Link Tapped',
  'Module Viewed',
  'Scroll Depth',
  'Slider Bar Clicked',
  'Visitor ID Set',
]);

/** Push a Segment-shaped event into the GTM dataLayer, tagged with the anon ID. */
export function pushGtmEvent(eventName: string, properties: object = {}): void {
  if (!isBrowser() || !eventName) return;

  const dataLayer = (window.dataLayer ||= []);
  dataLayer.push({
    ...properties,
    segmentAnonymousId: getCookieValue(ANON_ID_COOKIE),
    event: eventName,
  });
}
